import { head } from "lodash";
import { UseQueryResult } from "react-query";
import { Meta } from "../network/models/api.model";

export default class QueryUtil {
  public static processGetQuery<T>(
    query: UseQueryResult<
      {
        data: T[];
        meta: Meta;
        byId?: { [id: string]: T } | undefined;
      },
      unknown
    >
  ) {
    const queryData = query?.data;
    return {
      ...query,
      data: {
        ...queryData,
        data: queryData?.data ?? [],
        // fieldsDetail: FieldsDetailUtil.filterInitialFieldsDetail(
        //   queryData?.meta?.fields?.base_fields
        // ),
      },
    };
  }

  public static processSingleDataGetQuery<T>(
    query: UseQueryResult<
      {
        data: T;
        meta: Meta;
      },
      unknown
    >
  ) {
    const queryData = query?.data;
    return {
      ...query,
      data: {
        ...queryData,
        data: queryData?.data,
        // fieldsDetail: FieldsDetailUtil.filterInitialFieldsDetail(
        //   queryData?.meta?.fields?.base_fields
        // ),
      },
    };
  }

  public static processGetByIdQuery<T>(
    query: UseQueryResult<
      {
        data: T;
        meta: Meta;
      },
      unknown
    >
  ) {
    const queryData = query?.data;
    return {
      ...query,
      data: {
        ...queryData,
        // fieldsDetail: FieldsDetailUtil.filterInitialFieldsDetail(
        //   queryData?.meta?.fields?.base_fields
        // ),
      },
    };
  }

  public static processGetQueryReturnFirstIndex<T>(
    query: UseQueryResult<
      {
        data: T[];
        meta: Meta;
      },
      unknown
    >
  ) {
    const queryData = query?.data;
    return {
      ...query,
      data: {
        ...queryData,
        data: head(queryData?.data),
        // fieldsDetail: FieldsDetailUtil.filterInitialFieldsDetail(
        //   queryData?.meta?.fields?.base_fields
        // ),
      },
    };
  }
}
